module.exports = __webpack_public_path__ + "static/3A841E_2_0-2b9c4190523a28ec97b8ddf17b82c9a5.svg";